import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import {
  InternalShopFilters,
  InternalShopInventoryEventsFilters,
  InternalShopInventoryFilters,
} from './internal-shop.types';
import { loaders } from './internal-shop.loaders';
import { converters } from './internal-shop.converters';

export const internalShopKeys = queryKeyFactory('internal-shop');

export const useInternalShopItems = (
  filters: Partial<InternalShopFilters> = {},
) => {
  return useQuery({
    queryKey: internalShopKeys.list(filters),
    queryFn: () => loaders.getItems({ filters }),
    select: converters.getItems,
  });
};

export const useInternalShopItem = (itemId: string) => {
  return useQuery({
    queryKey: internalShopKeys.detail(itemId),
    queryFn: () => loaders.getItem({ itemId }),
    select: converters.getItem,
    enabled: !!itemId,
  });
};

export const useInternalShopInventoryItems = (
  filters: Partial<InternalShopInventoryFilters> = {},
) => {
  return useQuery({
    queryKey: internalShopKeys.list('inventory', filters),
    queryFn: () => loaders.getInventoryItems({ filters }),
    select: converters.getInventoryItems,
  });
};

export const useInternalShopInventoryEvents = (
  variantId: string,
  filters: Partial<InternalShopInventoryEventsFilters> = {},
) => {
  return useQuery({
    queryKey: internalShopKeys.list('inventory', variantId, filters),
    queryFn: () => loaders.getInventoryEvents({ variantId, filters }),
    select: converters.getInventoryEvents,
    enabled: !!variantId,
  });
};
